import { render } from "./StoreInput.vue?vue&type=template&id=513036ff&scoped=true"
import script from "./StoreInput.vue?vue&type=script&lang=js"
export * from "./StoreInput.vue?vue&type=script&lang=js"

import "./StoreInput.vue?vue&type=style&index=0&id=513036ff&scoped=true&lang=css"

import exportComponent from "E:\\GoWorkSpace2\\src\\storedisk\\storedisk\\storedisk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513036ff"]])

export default __exports__